import React from 'react';
import styled from 'styled-components';
import MenuItem from '@material-ui/core/MenuItem';
import {TextFieldProps} from '@material-ui/core';
import {TextFieldSelect} from 'epic-ue-components';
import {Chevron} from './Chevron';

export interface SelectOption {
    label?: string;
    value?: string | number;
}

interface SelectProps extends Omit<TextFieldProps, 'select'> {
    options: SelectOption[];
}

const StyledTextFieldSelect = styled(TextFieldSelect)`
    height: 56px;

    label,
    .Mui-focused {
        color: #fff !important;
        font-family: 'Inter' !important;

        .MuiFormLabel-asterisk {
            color: #ffa640 !important;
        }
    }

    .MuiInputBase-root {
        height: 56px;
        border-radius: 8px;
        background: transparent;

        .MuiSelect-root {
            height: 56px !important;
            border-radius: 8px;
            font-family: 'Inter';
            font-size: 16px;
            line-height: 20px;
            letter-spacing: 0.2px;
            border: 1px solid rgba(255, 255, 255, 0.5);
            box-sizing: border-box;
            padding-top: 25px !important;
            background-color: rgb(29, 29, 29) !important;
        }

        fieldset {
            border: none;
        }
    }
`;

const Select: React.FC<SelectProps> = ({options, ...selectProps}) => (
    <StyledTextFieldSelect
        required
        fullWidth
        variant="outlined"
        SelectProps={{
            IconComponent: Chevron
        }}
        {...selectProps}>
        {options.map(({value, label}) => (
            <MenuItem key={value} value={value}>
                {label}
            </MenuItem>
        ))}
    </StyledTextFieldSelect>
);

export default Select;
